const s = {
  "diagnostics-legend": "diagnostics-legend",
  "diagnostics-legend__heading": "diagnostics-legend__heading",
  "diagnostics-legend__list": "diagnostics-legend__list",
  "diagnostics-legend__entry": "diagnostics-legend__entry",
  "diagnostics-legend__term": "diagnostics-legend__term",
  "diagnostics-legend__footnote": "diagnostics-legend__footnote",
  "diagnostics-legend__description": "diagnostics-legend__description",
  "diagnostics-legend__description--after-term": "diagnostics-legend__description--after-term",
  "diagnostics-legend__note": "diagnostics-legend__note",
  "diagnostics-legend__swatches": "diagnostics-legend__swatches",
  "diagnostics-legend__swatch": "diagnostics-legend__swatch",
  "diagnostics-legend__swatch--near-patient-care": "diagnostics-legend__swatch--near-patient-care",
  "diagnostics-legend__swatch--pathology-lab": "diagnostics-legend__swatch--pathology-lab",
  "diagnostics-legend__swatch--digital-solution": "diagnostics-legend__swatch--digital-solution",
  "diagnostics-legend__swatch--core-lab": "diagnostics-legend__swatch--core-lab",
  "diagnostics-legend__swatch--molecular-lab": "diagnostics-legend__swatch--molecular-lab",
  "diagnostics-legend__swatch--diagnostics-insights": "diagnostics-legend__swatch--diagnostics-insights",
  "diagnostics-legend__swatch--healthcare-insights": "diagnostics-legend__swatch--healthcare-insights",
  "diagnostics-legend__swatch--other": "diagnostics-legend__swatch--other",
  "diagnostics-legend__visually-hidden": "diagnostics-legend__visually-hidden"
};
export {
  s as default
};
